import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-custom-alert',
  templateUrl: './custom-alert.component.html',
  styleUrl: './custom-alert.component.scss'
})
export class CustomAlertComponent {
  message: string = ''
  @Input() visible: boolean = false;
  @Output() hide: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() trainingId: string = '';


  constructor(private dataService: DataService) { }

  hideModal() {
    this.message = ''
    this.hide.emit(true);
  }


  async sendAlert() {
    if (!!this.trainingId && !!this.message) {
      let res = await this.dataService.postData(`notification/training/${this.trainingId}`, { message: this.message });
      if (!res.error) {
        this.hideModal();
        return;
      }
    }
  }
}
